import type { Breakpoints } from "@/ts/types";
export const appendHtmlToHead = (html: string, callback?: () => void): Window => {
    const fragment = document.createRange().createContextualFragment(html);
    const scriptTags = Array.from(fragment.querySelectorAll("script"));
    for (const script of scriptTags) {
        if (callback && script.src) {
            script.onload = callback;
        }
    }
    document.head.appendChild(fragment);
    return window; // Return the global window object after appending
};
export const appendHtmlToIframe = (html: string, callback?: () => void): Window => {
    // Create a hidden iframe if it doesn't exist
    let iframe = document.getElementById("magnite-iframe") as HTMLIFrameElement;
    if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.id = "magnite-iframe";
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    }
    const iframeDoc = iframe.contentDocument;
    if (!iframeDoc) {
        console.warn("Failed to access iframe document");
        return window; // Fallback to main window if iframe creation fails
    }
    // Ensure iframe window has SyntaxError constructor for happy-dom compatibility
    // Workaround for https://github.com/capricorn86/happy-dom/issues/1762
    if (process.env.NODE_ENV === "test" &&
        iframe.contentWindow &&
        // @ts-expect-error from the workaround
        !iframe.contentWindow.SyntaxError) {
        // @ts-expect-error from the workaround
        iframe.contentWindow.SyntaxError = SyntaxError;
    }
    const fragment = iframeDoc.createRange().createContextualFragment(html);
    const scriptTags = Array.from(fragment.querySelectorAll("script"));
    for (const script of scriptTags) {
        if (callback && script.src) {
            script.onload = callback;
        }
    }
    iframeDoc.head.appendChild(fragment);
    return iframe.contentWindow || window; // Return the iframe's window object
};
export const BREAKPOINTS = {
    xs: 320,
    s: 360,
    m: 728,
    l: 1024,
    xl: 1240,
};
export const getWidth = (): Breakpoints => {
    const isXsmall = window.matchMedia(`(max-width: ${BREAKPOINTS.s - 1}px)`).matches;
    const isSmall = window.matchMedia(`(max-width: ${BREAKPOINTS.m - 1}px)`).matches;
    const isMedium = window.matchMedia(`(min-width: ${BREAKPOINTS.m}px) and (max-width: ${BREAKPOINTS.l - 1}px)`).matches;
    const isLarge = window.matchMedia(`(min-width: ${BREAKPOINTS.l}px) and (max-width: ${BREAKPOINTS.xl - 1}px)`).matches;
    if (isXsmall) {
        return "xsmall";
    }
    if (isSmall) {
        return "small";
    }
    if (isMedium) {
        return "medium";
    }
    if (isLarge) {
        return "large";
    }
    return "xlarge";
};
